import React, { Component } from 'react';
import authService from './api-authorization/AuthorizeService'
import 'react-calendar/dist/Calendar.css';
import 'reactjs-popup/dist/index.css';
import Input from 'react-phone-number-input/input';
import Select from 'react-select';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Contacts } from '@capacitor-community/contacts';
import { Capacitor } from '@capacitor/core';
import { CallNumber } from 'capacitor-call-number';

export const BookingControl = injectIntl(class extends Component {
  constructor(props) {
    super(props);
    var curDate = new Date();
    curDate.setHours(0,0,0,0);
    this.state = {
      duration: 1,
      phone: '+7',
      manualPhone: '+7',
      userName: undefined,
      partialBooking: null,
      partialBookingText: '',
      orderParams: props.orderParams ?? [],
      contacts: [],
    };
  }

  async componentDidMount() {
    await this.loadContacts();
  }

  async cancelOrder(id) {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/orders/${id}`, {
      method: "DELETE",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) {
      return;
    }
    await response.json();
    this.setState(prevState => ({...prevState, orders: prevState.orders.filter(order => order.id !== id)}));
  }

  increaseDuration(shift, res, maxTime, minTime) {
    var newDur = this.state.duration + shift;
    if (newDur > /*res.maxTime / 3600*/maxTime)
      newDur = /*res.maxTime / 3600*/maxTime;
    if (newDur < (minTime??res.minTime) / 3600)
      newDur = (minTime??res.minTime) / 3600;
    if (newDur !== this.state.duration)
      this.setState(prevState => ({...prevState, duration: newDur}));
    return newDur;
  }

  displayDuration(dur, res) {
    var newDur = dur;
    if (res.bookingInterval === 4)
      newDur = newDur / 24;
    return newDur;
  }

  async createOrder(resourceId, time, serviceId, date, price, callback) {
    var { callback, completeCallback } = this.props;
    if (this.state.colorchange || !serviceId) {
      return;
    }
    this.setState(prevState => ({...prevState, colorchange: true}));
    setTimeout(async () => {
      const startTime = Date.now();
      const token = await authService.getAccessToken();

      var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
      date = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
      const response = await fetch(`{{mainApiUrl}}api/orders`, {
        method: "POST",
        headers: {
          ...headers,
          'Accept': 'application/json, text/plain',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ serviceId: serviceId, resourceId: resourceId, start: time, end: time + Math.floor(this.state.duration)*100 + this.state.duration*100%100*0.6, date: date, userPhone: this.state.userName?.fixed?this.state.userName.value:this.state.manualPhone, userName: this.state.userName?.label?.replace(" (Новый)", ""), partialBooking: this.state.partialBooking, partialBookingText: this.state.partialBookingText, orderParams: this.state.orderParams.map(op => op.id), delivery: this.state.delivery, deliveryBack: this.state.deliveryBack, price: price })
      });
      if (!response.ok) {
        this.setState(prevState => ({...prevState, colorchange: undefined, errorBooking: "Бронирование не подтверждено"}));
        return;
      }
      const data = await response.json();
      data.date = date;
      await callback(true, true);

      const remainingTime = 3000 - (Date.now() - startTime);
      setTimeout(() => {
        this.setState(prevState => ({...prevState, phone: '+7', manualPhone: '+7', userName: undefined, partialBooking: null, partialBookingText: '', colorchange: undefined, errorBooking: undefined, newbooking: undefined}));
        completeCallback(data);
      }, remainingTime > 0 ? remainingTime : 0);
    }, 0);
  }

  async cancelOrder(id, callback) {
    var { callback } = this.props;
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/orders/${id}`, {
      method: "DELETE",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) {
      return;
    }
    await response.json();
    this.setState(prevState => ({...prevState/*, orders: prevState.orders.filter(order => order.id !== id)*/}));
    callback(false, true);
  }

  renderIncreaseButton(shift, res, maxTime, minTime) {
    return (
      <input style={{marginBottom: "5px"}} className="btn btn-primary" type="button" value={(shift > 0 ? '+' : '') + this.displayDuration(shift, res).toString()} id="Button_Plus05" onClick={() => this.increaseDuration(shift, res, maxTime, minTime)}/>
    );
  }

  getDurWord(service, time) {
    if (service.bookingInterval == 4) {
      if (time/86400 == 1) {
        return "день";
      }
      return `дн${time/86400>=2 && time/86400<=4?"я":"ей"}`;
    }
    var word = "час";
    if (time/3600 != 1) {
      word += time/3600>=2 && time/3600<=4?"а":"ов";
    }
    return word;
  }

  updatePartialBookingText(evt) {
    const val = evt.target.value;
    this.setState(prevState => ({...prevState, partialBookingText: val}));
  }

  setParamOptional(val, id, price) {
    const orderParams = this.state.orderParams.filter(op => op.id !== id);
    if (val) {
      orderParams.push({id: id, price: price});
    }
    this.setState(prevState => ({...prevState, orderParams: orderParams}));
  }

  getOptionalAmount() {
    var sum = 0;
    this.state.orderParams.forEach(a => sum += a.price);
    return sum;
  }

  getPartialBookingSum(orders) {
    var sum = 0;
    orders.forEach(o => sum += 1 / o.partialBooking);
    return sum;
  }

  getPartialBookingText(orders) {
    var sum = 0;
    var minPart = Math.max(...orders.map(o => o.partialBooking));
    orders.forEach(o => sum += minPart / o.partialBooking);
    return `${sum} / ${minPart}`;
  }

  paramsExist(services) {
    if (services.length == 0)
      return false;
    var found = false;
    services[0].params?.forEach(p => {
      if (p.items.filter(i => !i.optional || i.companyServices.length > 0).length > 0) {
        found = true;
      }
    })
    return found;
  }

  getSelectedDate(pos, bookingInterval, time) {
    var { selectedMonth, selectedDate } = this.props;
    var date = selectedDate;
    if (bookingInterval === 4) {
      date = new Date(selectedMonth.getTime());
      date.setDate(pos);
    } else if (time) {
      date = new Date(selectedDate);
      date.setHours(pos);
    }
    return date;
  }

  async call(phoneNumber) {
    try {
      await CallNumber.call({ number: phoneNumber, bypassAppChooser: false });
    } catch (error) {
      console.log(error);
    }
  }

  async loadContacts() {
    if (this.state.contacts && this.state.contacts.length > 0) {
      return;
    }
    this.setState(prevState => ({...prevState, loadingContacts: true }));
   
    try {
      var permissionResult;
      if (Capacitor.getPlatform() === 'web') {
        permissionResult = await navigator.permissions.query({name: 'contacts'});
      } else {
        permissionResult = await Contacts.requestPermissions();
      }
     
      console.log(permissionResult);
      if (permissionResult.granted || permissionResult.contacts === 'granted' || permissionResult.state === 'granted') {
        const result = await Contacts.getContacts({projection:{name:true,phones:true}});
        this.setState(prevState => ({...prevState, contacts: result.contacts.filter(c => c.phones?.length > 0 && c.name?.display?.length > 0).map(c => ({value: c.phones[0].number.replaceAll(" ","").replaceAll("-","").replaceAll("(","").replaceAll(")",""), label: c.name.display, fixed: true})) }));
        console.log('Contacts loaded:', result.contacts.length);
        console.log('Contacts loaded:', result.contacts);
      } else {
      }
    } catch (error) {
      console.error('Contacts error:', error);
    } finally {
      this.setState(prevState => ({...prevState, loadingContacts: false }));
    }
  }

  getDelPhone() {
    return this.state.phone.length>2?this.state.phone.substring(0,this.state.phone.length-1):"+7";
  }
  
  render() {
    var { selectedServiceId, services, pos, res, orders, min, baseOrders, isAuthenticated } = this.props;
    console.log(res);
    const filteredServices = res.services.filter(c => services.filter(s => s.id === c.serviceId).length === 1);
    var serviceId = selectedServiceId > 0 ? selectedServiceId : (this.state.selectedService?.value ?? filteredServices[0]?.serviceId);
    var service = filteredServices.filter(s => s.serviceId === serviceId)[0];
    if (!service) {
      return <></>;
    }

    var price = 0;
    var duration = 0;
    var deliveryDuration = 0;
    var minTime = service.minTime;
    if (service.bookingInterval == 4 && res.slots && res.slots.filter(s => s.day == Math.trunc(pos)).length > 0 && res.slots.filter(s => s.day == Math.trunc(pos))[0].minTime) {
      minTime = res.slots.filter(s => s.day == Math.trunc(pos))[0].minTime;
    }
    if (res.delivery !== null && (this.state.delivery || this.state.deliveryBack || res.delivery === true) && res.deliveryBillingTime) {
      deliveryDuration = res.deliveryBillingTime;
      if (this.state.delivery && this.state.deliveryBack) {
        deliveryDuration += res.deliveryBillingTime;
      }
    }
    if (service.bookingInterval == 4 && res.slots) {
      for (var curpos = pos; curpos < this.displayDuration(this.state.duration, service) + pos + deliveryDuration; curpos++) {
        const slot = res.slots.filter(s => s.day == Math.trunc(curpos))[0];
        price += (slot?.firstIntervalPrice ?? service.firstIntervalPrice) && curpos == pos ? (slot?.firstIntervalPrice ?? service.firstIntervalPrice) : (slot?.price ?? service.price);
        var intervals = slot?.firstIntervalPriceIntervals ?? service.firstIntervalPriceIntervals;
        if (intervals && curpos == pos) {
          curpos += (intervals - 1) > 0 ? (intervals - 1) : 0;
        }
      }
      duration = curpos - pos;
    } else {
      if (service.firstIntervalPrice) {
        duration = this.displayDuration(this.state.duration, service) - (service.firstIntervalPriceIntervals ? service.firstIntervalPriceIntervals : 1);
        price = service.firstIntervalPrice;
      } else {
        duration = this.displayDuration(this.state.duration, service);
      }
      duration += deliveryDuration;
      price += service.price * (duration > 0 ? duration : 0);
    }
    if (res.delivery !== null && (this.state.delivery || this.state.deliveryBack || res.delivery === true) && res.deliveryPrice) {
      price += res.deliveryPrice;
      if (this.state.delivery && this.state.deliveryBack) {
        price += res.deliveryPrice;
      }
    }
    price /= (this.state.partialBooking ? this.state.partialBooking : 1);
    var ap = 0;
    service.additionalPayments.filter(p => !p.included).forEach(p => ap += p.additionalPayment.percent ? Math.trunc(price * p.additionalPayment.amount / 100) : (p.additionalPayment.amount*(p.additionalPayment.perInterval?duration:0)));
    //price += ap;

    var selectedDate = this.getSelectedDate(pos, service.bookingInterval).toLocaleString(undefined, {weekday: "long", year: 'numeric', month: '2-digit', day: '2-digit'});
    if (orders && orders.length > 0 && !this.state.newbooking) {
      return (
        <div>
          <div><span>{orders.filter(o => o.userId).length > 0 ? <>Ваше</> : <>Уже есть</>} бронировани{orders.length > 1 ? 'я' : 'е'} на {selectedDate}</span></div>
          {orders.map(order => {
            const contact = this.state.contacts.filter(c => c.value == order.userPhone)[0];
            return (order.userId ?
            <>
            {service.bookingInterval === 4 ? <></> : (<div>В {Math.floor(order.start / 100)}:{(order.start % 100).toString().padStart(2, '0')}</div>)}
            <div><span>Имя: </span>{order.userName}</div>
            <div><span>Телефон: </span>
            {!contact ? (Capacitor.isNativePlatform() ? <><a class="aphone" onClick={() => this.call(order.userPhone)}>{order.userPhone}</a> <div className="btnaddcontact" id="Button_AddContact" onClick={() => this.addContact(order.userPhone, order.userName)}></div></> : <a class="aphone" href={`tel:${order.userPhone}`}>{order.userPhone}</a>) :
            <div title={order.userPhone} className="btncontact" id="Button_Contact" onClick={() => this.call(order.userPhone)}>{contact.label}</div>}
            </div>
            <div>Услуга: {order.service}</div>
            {service.partialBooking && order.partialBookingText ? <div>Комментарий для участников: {order.partialBookingText}</div>: <></>}
            {order.price > 0 ? <div>Цена: <b>{order.price} руб.</b></div> : <></>}
            <div className="btnbooked" id="Button_Book">Бронирование подтверждено</div>
            <div className="btncancel" id="Button_Cancel" onClick={() => {this.cancelOrder(order.id); /*closeTooltip();*/}}>X</div>
            </> : (service.partialBooking && order.partialBookingText ? <div>Комментарий другого участника: {order.partialBookingText}</div> : <></>)
            );})}
          {orders.length < res.count || (service.partialBooking && this.getPartialBookingSum(orders) < 1) ? <div><input style={{marginTop: "5px"}} className="btn btn-primary" type="button" value="Еще одно бронирование" id="Button_New" onClick={() => this.setState(prevState => ({...prevState, newbooking: true}))}/></div> : <></>}
        </div>
      );
    } else {
      var maxTime1 = service.maxTime/3600*100;
      var maxTime = Math.floor(pos*(service.bookingInterval==4?24:1)+maxTime1/100+min/60)*100+(((pos*(service.bookingInterval==4?24:1)+maxTime1/100+min/60)*100)%100)/100*60;
      var filteredMaxTime = baseOrders.filter(cal => res.id === cal.resourceId && (service.bookingInterval==4 || (cal.start > (pos*100+min) && cal.start < (maxTime))));
      filteredMaxTime = filteredMaxTime.filter(cal => new Date(cal.date).getTime() >= this.getSelectedDate(pos, service.bookingInterval).getTime() && new Date(cal.date).getTime()<=this.getSelectedDate((maxTime/100*3600-1)/(service.bookingInterval==4?86400:3600), service.bookingInterval).getTime());
      for (; filteredMaxTime.length > res.count - 1 && maxTime1 > 0; ) {
        maxTime1 -= (service.bookingInterval==4?2400:50);
        maxTime = Math.floor(pos*(service.bookingInterval==4?24:1)+maxTime1/100+min/60)*100+(((pos*(service.bookingInterval==4?24:1)+maxTime1/100+min/60)*100)%100)/100*60;
        filteredMaxTime = filteredMaxTime.filter(cal => res.id === cal.resourceId && (service.bookingInterval==4 || (cal.start > (pos*100+min) && cal.start < (maxTime))));
        filteredMaxTime = filteredMaxTime.filter(cal => new Date(cal.date).getTime() >= this.getSelectedDate(pos, service.bookingInterval).getTime() && new Date(cal.date).getTime()<=this.getSelectedDate((maxTime/100*3600-1)/(service.bookingInterval==4?86400:3600), service.bookingInterval).getTime());
      }
      maxTime = maxTime1 - (res.serviceTime??0)/60*100;

      var incButtons = maxTime/100 !== minTime/3600 ?
          <span>{this.renderIncreaseButton(service.timeStep > 0 ? service.timeStep / 3600 : 0.5, service, maxTime/100, minTime)}
          {this.renderIncreaseButton(service.timeStep > 0 ? service.timeStep / 3600 * 2 : 1, service, maxTime/100, minTime)}</span>
        : <span></span>;
      var decButtons = maxTime/100 !== minTime/3600 ?
          <span>{this.renderIncreaseButton(service.timeStep > 0 ? -service.timeStep / 3600 * 2 : -1, service, maxTime/100, minTime)}
          {this.renderIncreaseButton(service.timeStep > 0 ? -service.timeStep / 3600 : -0.5, service, maxTime/100, minTime)}</span>
        : <span></span>;

      var cancelationTime = new Date(this.getSelectedDate(pos, service.bookingInterval));
      if (service.cancelationHours)
      {
        //cancelationTime.setTime(cancelationTime.getTime()-service.cancelationHours*1000)
        cancelationTime.setDate(cancelationTime.getDate()-Math.trunc(service.cancelationHours/24/3600));
        if (service.bookingInterval != 4) {
          cancelationTime.setTime(cancelationTime.getTime()+(pos+min/60-service.cancelationHours/3600%24)*3600*1000);
        }
      }
      const optionalAmount = this.getOptionalAmount() * this.displayDuration(this.state.duration, service);
      const textDuration = this.displayDuration(this.increaseDuration(0, service, maxTime/100, minTime), service) + ' ' + this.getDurWord(service, this.increaseDuration(0, service, maxTime/100, minTime)*3600);
      const testcontacts = this.state.contacts;
      //testcontacts.push({ value: "+79757654674", label: "Юрий", fixed: true });
      //testcontacts.push({ value: "+79617876876", label: "Михаил", fixed: true });

      var contacts = [];
      console.log(this.state.userName);
      if (this.state.tempName && testcontacts.filter(c => c.value == this.state.tempName.value).length == 0) {
        contacts.push(this.state.tempName);
      }
      else if (this.state.userName && testcontacts.filter(c => c.value == this.state.userName.value).length == 0) {
        contacts.push(this.state.userName);
      }
      contacts = [...contacts, ...testcontacts];
      return (
        <div>
          <div><span>Вы создаете бронирование на {selectedDate}</span></div>
          {service.bookingInterval === 4 ? <></> : <div>В {pos}:{(min??0).toString().padStart(2, '0')}</div>}
          {res.admin ?
          <>
          <div class="bookphone"><label for="uName">Имя</label><div><Select
              className="formselectinline2"
              classNamePrefix="select"
              isDisabled={false}
              isClearable={false}
              isSearchable={true}
              options={contacts}
              placeholder={this.props.intl.formatMessage({id: "search_contacts"})}
              noOptionsMessage={() => this.props.intl.formatMessage({id: "no_results"})}
              onInputChange={(newValue) => this.setState(prevState => ({...prevState, tempName: newValue.length > 0 ? {value: this.state.manualPhone, label: newValue + " (Новый)"} : undefined}))}
              onChange={(newValue) => this.setState(prevState => ({...prevState, userName: newValue, tempName: undefined, phone: newValue.fixed ? newValue.value : this.state.manualPhone}))}
              value={this.state.userName !== undefined ? this.state.userName : ''}
              name="uName"
            /><div className="history"></div></div>
          </div>
          <div class="bookphone"><label for="telNo">Телефон</label> <Input class="phoneinput" country="RU"
            value={this.state.phone !== undefined ? this.state.phone : ''}
            onChange={val => {this.setState(prevState => ({...prevState, phone: val, manualPhone: this.state.userName?.fixed?this.state.manualPhone: val})); this.populateUserData();}} disabled/>
            <span className="backsp" onClick={() => {this.setState(prevState => ({...prevState, phone: this.getDelPhone(), manualPhone: this.state.userName?.fixed?this.state.manualPhone: this.getDelPhone()})); this.populateUserData();}}/>
          </div>
          <div style={{textAlign: "center"}}>{Array.from(Array(10).keys()).map(i => <input key={i} className="btn btn-primary btn-phone" type="button" value={i==9?0:(i+1)} id={"Button_"+(i+1)} onClick={() => {this.setState(prevState => ({...prevState, phone: this.state.phone + (i==9?0:(i+1)).toString(), manualPhone: this.state.userName?.fixed?this.state.manualPhone: this.state.phone + (i==9?0:(i+1)).toString()})); this.populateUserData();}}/>)}</div>
          </> : <></>}
          {res.images && res.images.length > 0 ? <div><img style={{width: "100%"}} src={res.images[0]}/></div> : <></>}
          <div>Услуга{filteredServices.filter(s => selectedServiceId === 0 || s.serviceId === serviceId).length > 1 ?
            <Select
              className="formselect"
              classNamePrefix="select"
              isDisabled={false}
              isClearable={false}
              isSearchable={true}
              options={filteredServices.map(c => ({ value: c.serviceId, label: services.filter(s => s.id === c.serviceId)[0]?.name }))}
              placeholder={this.props.intl.formatMessage({id: "search_services"})}
              noOptionsMessage={() => this.props.intl.formatMessage({id: "no_results"})}
              onChange={(newValue) => this.setState(prevState => ({...prevState, selectedService: newValue}))}
              value={this.state.selectedService??{ value: service.serviceId, label: services.filter(s => s.id === service.serviceId)[0]?.name }}
              name="service"
            /> :
            <>: <b>{services.filter(c => c.id === filteredServices.filter(s => selectedServiceId === 0 || s.serviceId === serviceId)[0]?.serviceId)[0]?.name}</b></>}
          </div>
          {this.paramsExist(filteredServices?.filter(ser => ser.serviceId === serviceId)) ? <div><b>Параметры</b></div> : <></>}
          {filteredServices?.filter(ser => ser.serviceId === serviceId).length > 0 && filteredServices?.filter(ser => ser.serviceId === serviceId)[0].params?.map(p => p.items.filter(i => !i.optional || i.companyServices.length > 0).length > 0 ? <div style={{marginLeft: "10px"}}>{p.name ? <span>{p.name + ": "}</span> : <></>}{p.items.map(i => i.optional
          ? (i.companyServices.length > 0 ? <><input style={{margin: "5px 5px 0 3px"}} class="form-check-input" type="checkbox" id={"Input_Optional_"+i.id} name="Input.Optional"
            checked={this.state.orderParams.filter(op => op.id === i.id).length > 0}
            onChange={evt => {const val = evt.target.checked; this.setParamOptional(val, i.id, i.companyServices[0].price);}}
          />
          <label style={{display: "contents"}} for={"Input_Optional_" + i.id}>{i.name} <b>({i.companyServices[0].price} руб.)</b></label></> : <></>)
          : <span>{i.name + " "}</span>)}</div> : <></>)}
          {res.delivery === false ? <>
          <input style={{margin: "5px 5px 0 0"}} class="form-check-input" type="checkbox" id={"Input_Delivery"} name="Input.Delivery"
            checked={this.state.delivery}
            onChange={evt => {const val = evt.target.checked; this.setState(prevState => ({...prevState, delivery: val}));}}
          /><label style={{display: "contents"}} for={"Input_Delivery"}>Доставка {res.deliveryPrice ? <b>({res.deliveryPrice} руб.)</b> : <b>бесплатно</b>}</label>
          {res.deliveryOneDirection?<div><input style={{margin: "5px 5px 0 0"}} class="form-check-input" type="checkbox" id={"Input_DeliveryBack"} name="Input.DeliveryBack"
            checked={this.state.deliveryBack}
            onChange={evt => {const val = evt.target.checked; this.setState(prevState => ({...prevState, deliveryBack: val}));}}
          /><label style={{display: "contents"}} for={"Input_DeliveryBack"}>Доставка обратно{res.deliveryPrice ? <b>({res.deliveryPrice} руб.)</b> : <b>бесплатно</b>}</label></div> : <></>}
          </> : <></>}
          {res.delivery === true ? <><label style={{display: "contents"}} for={"Input_Delivery"}>Только доставка {res.deliveryPrice ? <b>({res.deliveryPrice} руб.)</b> : <b>бесплатно</b>}</label></> : <></>}
          {service.partialBooking ?
            (<>
              <div><span className="radio-primary">
              <input name="PartialBooking" type="radio" value="RadioComplete" id="RadioComplete" checked={this.state.partialBooking === null} onClick={() => this.setState(prevState => ({...prevState, partialBooking: null}))}/><label className="btn btn-primary" for="RadioComplete">Полностью</label></span><span>Частично </span>
              <span className="radio-primary">
              {Array.from(Array(service.partialBooking + 1).keys()).map(i => i > 1 && service.partialBooking%i == 0 ? <><input name="PartialBooking" type="radio" value={'Radio' + i.toString()} id={'Radio'+i.toString()} checked={this.state.partialBooking===i} onClick={() => this.setState(prevState => ({...prevState, partialBooking: i}))}/><label className="btn btn-primary radio-gradient" for={'Radio'+i.toString()}>{'1 / ' + i.toString()}</label></> : <></>)}
              </span></div>
              {this.state.partialBooking?<div class="form-group">
                <label for="Input_PartialBookingText">Комментарий для участников</label>
                <textarea style={{marginBottom: "5px"}} class="form-control" type="text" id="Input_PartialBookingText" name="Input.PartialBookingText" value={this.state.partialBookingText} onChange={evt => this.updatePartialBookingText(evt)}/>
              </div> : <></>}
            </>)
          : <></>}
          {minTime ? <div>Длительность{maxTime/100 !== minTime/3600 ? <div> {decButtons} <b>{textDuration}</b> {incButtons}</div> : <>: <b>{textDuration}</b></>}</div> : <></>}
          {price + optionalAmount > 0 ? <div>Цена: <b>{price + optionalAmount} руб.</b></div> : <></>}
          {service.additionalPayments.length > 0 ? <><div><b>Налоги</b></div>
          <div style={{marginLeft: "10px"}}>
            {service.additionalPayments.map(p => <div>{p.additionalPayment.name}: {p.additionalPayment.percent?<>{p.additionalPayment.amount}% (<b>{Math.trunc(p.additionalPayment.amount*price/100)} руб.</b>)</> : <b>{p.additionalPayment.amount*(p.additionalPayment.perInterval?duration:0)} руб.</b>}{p.included ? <b> (включено)</b> : <></>}</div>)}
          </div>
            {ap > 0 ? <div>Дополнительно оплачивается: <b>{ap} руб.</b></div> : <></>}
          </> : <></>}
          <div>Бесплатная отмена: {service.cancelationHours > 0 ? <b>не позднее {cancelationTime.toLocaleString(undefined, {weekday: "long", year: 'numeric', month: '2-digit', day: '2-digit', hour: "2-digit", minute: "2-digit"})}</b> : <b>в любое время</b>}</div>
          {this.state.errorBooking ? <div style={{color: "red"}}>{this.state.errorBooking}</div> : <></>}
          {isAuthenticated ?
            <div className={"btnbook"+(this.state.colorchange ? " color-change":"") + (!serviceId?" btngray":"")} id="Button_Book" disabled={!service.minTime} onClick={() => {this.createOrder(res.id, service.bookingInterval==4?0:(pos*100 + (min??0)), serviceId, this.getSelectedDate(pos, service.bookingInterval), price + ap); /*closeTooltip();*/}}>Забронировать</div> :
            <a class="btn btn-primary" href="authentication/login">Войти</a>}
        </div>
      );
    }
  }

  async populateUserData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/users/phone?phone=${encodeURIComponent(this.state.phone)}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) {
      return;
    }
    const data = await response.json();

    const response2 = await fetch(`{{userApiUrl}}api/users/phone?phone=${encodeURIComponent(this.state.phone)}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    if (!response2.ok) {
      return;
    }
    const data2 = await response2.json();
    this.setState(prevState => ({...prevState, globalUsersMain: data, globalUsersIdentity: data2, userName: data.length == 1 ? {label: data[0].firstName, value: this.state.manualPhone, fixed: true} : this.state.userName}));
  }
})